/** @format */

import { createSlice } from '@reduxjs/toolkit'
import { request } from 'src/utils'
import _ from 'lodash'
import Api from 'src/api/ApiCommon'
export type GlobalDataKey =
  | 'productList'
  | 'monitorRegionList'
  | 'productMenu'
  | 'productSubMenu'
  | 'templateList'
  | 'userList'

const API: Record<GlobalDataKey, string> = {
  productList: '/monitor/?Action=DescribeMonitorProductList&Version=2021-01-01',
  monitorRegionList: '/monitor/?Action=DescribeMonitorRegions&Version=2021-01-01',
  productMenu: Api.getProductMenu,
  productSubMenu: Api.getProductMenu,
  templateList: '/monitor/?Action=DescribeConditionsTemplates&Version=2024-01-01',
  userList: '' // Mock数据，不需要API
}

interface StartTimeType {
  startTime?: number
}

// 产品类型
export interface ProductStateType extends StartTimeType {
  list: {
    productName: string
    productType: number
    namespace: string
    costOptFlag?: number
    iamProjectFlag?: number
  }[]
}

// 监控机房列表
export interface RegionStateType extends StartTimeType {
  list: {
    regionId: number
    regionKey: string
    regionName: string
  }[]
}

// 云服务类别菜单
export interface ProductMenu extends StartTimeType {
  list: {
    title: string
    productType: number
    link: string
    namespance: string
    subMenus: ProductMenu[] | []
  }[]
}

// 用户类型
export interface User {
  id: number
  code: string
  name: string
  cname: string
  email: string
  phone: string
  status: number
  is_super: boolean
  created_at: string
  updated_at: string
}

export interface UserListType extends StartTimeType {
  list: User[]
}
//
interface GlobalDataType {
  productList: ProductStateType
  monitorRegionList: RegionStateType
  productMenu: ProductMenu
  productSubMenu: ProductMenu
  templateList: any
  userList: UserListType
}

// 初始化数据
const initialState: GlobalDataType = {
  productList: { startTime: 0, list: [] },
  monitorRegionList: { startTime: 0, list: [] },
  productMenu: { startTime: 0, list: [] },
  productSubMenu: { startTime: 0, list: [] },
  templateList: { startTime: 0, list: [] },
  userList: { startTime: new Date().valueOf(), list: [] }
}

export const globalDataSlice = createSlice({
  name: 'globalData',
  initialState,
  reducers: {
    setProductList(state, { payload }) {
      const { dataType, list, startTime } = payload
      state[dataType].list = list
      state[dataType].startTime = startTime
    }
  }
})

const params = {
  templateList: {
    ProductType: 999,
    PageSize: 9999
  }
}

const { setProductList } = globalDataSlice.actions

export const asyncGetProductList = dataType => {
  return asyncDispatch => {
    request(API[dataType], { data: params[dataType] || {} }).then(({ data }) => {
      const payload = {
        dataType,
        startTime: new Date().valueOf()
      }
      if (dataType === 'productList') {
        _.set(payload, 'list', data?.[dataType] || [])
      } else if (dataType === 'productMenu') {
        const concat = data?.data?.reduce((res, item) => res.concat(item?.subMenus || []), [])
        _.set(payload, 'list', concat || [])
      } else if (dataType === 'productSubMenu') {
        _.set(payload, 'list', data?.data)
      } else if (dataType === 'monitorRegionList') {
        _.set(payload, 'list', data?.data || [])
      } else if (dataType === 'templateList') {
        _.set(payload, 'list', data?.Templates || [])
      }
      asyncDispatch(setProductList(payload))
    })
  }
}

export default globalDataSlice.reducer
